import fetch from '../../app/utils/fetch';
import { cmxURL } from 'endpoints';
import { setLanguageBundle } from '@nackle/intl-tools';

const DEFAULT_LOCALE = 'en-US';

/*******************************************************************************
 * Initial state
 */
const initialState = {
    loading: false,
    user: {}
};

/*******************************************************************************
 * Non-async action types
 */
const LOADING_START = 'loading/start';
const LOADING_END   = 'loading/end';
const SET_USER_DETAILS   = 'state/setUserDetails';

/*******************************************************************************
 * Reducer
 */
export default function appReducer( state = initialState, action ) {
    switch ( action.type ) {
        case LOADING_START: {
            return {
                ...state,
                loading: true
            };
        }
        case LOADING_END: {
            return {
                ...state,
                loading: false
            };
        }
        case SET_USER_DETAILS: {
            return {
                ...state,
                user: action.user
            };
        }
        default:
            return state;
    }
}

/*******************************************************************************
 * Action creators
 */
export function startLoading( ) {
    return {
        type: LOADING_START
    };
}
export function endLoading( ) {
    return {
        type: LOADING_END
    };
}

export const setUserDetails = ( user ) => {
    return {
        type: SET_USER_DETAILS,
        user
    };
};

export const loadBundles = ( bundleNames, locale = DEFAULT_LOCALE ) => async () => {
    const bundleData = await Promise.all( bundleNames.map(
        bundleName => getBundle( bundleName, [ locale ] )
    ) );

    let mergedBundle = bundleData[ 0 ].bundles[ locale ];
    for ( let i = 1; i < bundleData.length; i++ ) {
        mergedBundle = {
            ...mergedBundle,
            ...bundleData[ i ].bundles[ locale ]
        };
    }

    await setLanguageBundle( locale, mergedBundle );
    return mergedBundle;
};

const getBundle = async ( bundleName, locales ) => {
    const res = await fetch(
        `${ cmxURL }/bundle/${ encodeURIComponent( bundleName ) }`,
        {
            method: 'POST',
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify( { locales } )
        }
    );

    const data = await res.json();

    if ( res.ok ) {
        return data;
    } else {
        throw data;
    }
};